import styled from 'styled-components';
import { ButtonSkeleton, Colors, Icon, MediaQuery } from '@pelando/components';
import { maximumGridStyle } from '@/presentation/styles/global';
import EmptyState from '../../../components/EmptyState';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;

  @media ${MediaQuery.SCREEN_LG_UP} {
    padding-top: 16px;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 16px;
  width: 100%;
  margin: 0 auto;

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${maximumGridStyle}
  }

  @media ${MediaQuery.SCREEN_LG_UP} {
    grid-template-rows: unset;
    grid-template-columns: minmax(auto, 375px) 1fr;
    min-height: 582px;
    gap: 16px;
  }
`;

export const NotFoundAccountState = styled(EmptyState)`
  margin: 135px 0;
`;

export const TabSkeleton = styled(ButtonSkeleton)`
  border-radius: 12px;
  width: 140px;
`;

export const EmptyIcon = styled(Icon)`
  color: rgb(${Colors.Gray});
  font-size: 48px;
`;

export const ContainerTabSkeleton = styled.div`
  margin-left: 0;
  display: flex;
  justify-content: center;
  gap: 8px;

  @media ${MediaQuery.SCREEN_LG_UP} {
    margin-left: 12px;
    justify-content: left;
  }
`;
